import React, { useState, useEffect } from 'react';
import LicenseAdminMenu from './menu';
import LicenseImport from './import';
import FormConfig from './formConfig';
import './index.css';
import ManageReview from './manageReview';
import ReviewStats from './reviewStats';

export const LicenseAdmin = () => {
    const [selectedSection, setSelectedSection] = useState('latestReview');

    useEffect(() => {
        
    }, [selectedSection]);

    const renderContent = () => {
        switch (selectedSection) {
            case 'latestReview':
                return <ReviewStats />;
            case 'manageReview':
                return <ManageReview />;
            case 'formConfig':
                return <FormConfig />;
            case 'importData':
                return <LicenseImport />;
            default:
                return null;
        }
    };

    return (
        <div className="license-container">
            <div className="license-menu">
                <LicenseAdminMenu onSelect={setSelectedSection} />
            </div>
            <div className="license-content">
                {renderContent()}
            </div>
        </div>
    );
};